import { unref } from 'vue'
import { isArray } from '@sgui-plus/utils/util'
import type { Ref } from 'vue'
import type { TooltipTriggerType } from './trigger'

export const isTriggerType = (trigger: TooltipTriggerType | TooltipTriggerType[], type: TooltipTriggerType) => {
  if (isArray(trigger)) {
    return trigger.includes(type)
  }
  return trigger === type
}

export const whenTrigger = (
  trigger: Ref<TooltipTriggerType | TooltipTriggerType[]>,
  type: TooltipTriggerType,
  handler: (e: Event) => void
) => {
  return (e: Event) => {
    isTriggerType(unref(trigger), type) && handler(e)
  }
}
